'use client';

import type { ReactNode } from 'react';
import { JwtRenderer } from '../../ToolCallsRenderers/renderers/JwtRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderJwtResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight } = ctx;
  return <JwtRenderer data={content} maxHeight={maxHeight} />;
};
